import { REFINANCING_LIMITS } from "shared/CalculatorLimits";
import type { RefinancingFormModel } from "web_myplann/Calculators/Types/RefinancingFormModel";

export const hasRefinancingInputs = ({
	propertyPrice,
	monthlyPayment,
	interest,
}: Pick<
	RefinancingFormModel,
	"propertyPrice" | "monthlyPayment" | "interest"
>) =>
	propertyPrice >= REFINANCING_LIMITS.propertyPriceMin &&
	propertyPrice <= REFINANCING_LIMITS.propertyPriceMax &&
	monthlyPayment > 0 &&
	monthlyPayment <= REFINANCING_LIMITS.monthlyPaymentMax &&
	interest > 0 &&
	interest <= REFINANCING_LIMITS.interestMax;
